"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cuvio": {
    "efd295b8": [{
      "hkey": "38c62df8",
      "slug": "cuvio",
      "name": "Cuvio",
      "primary": true,
      "skipSearch": false
    }],
    "carreggio": [{
      "hkey": "38c62df8",
      "slug": "cuvio",
      "name": "Cuvio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3841c27e": [{
      "hkey": "38c62df8",
      "slug": "cuvio",
      "name": "Cuvio",
      "primary": true,
      "skipSearch": false
    }],
    "fornaci": [{
      "hkey": "38c62df8",
      "slug": "cuvio",
      "name": "Cuvio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "81bdd150": [{
      "hkey": "38c62df8",
      "slug": "cuvio",
      "name": "Cuvio",
      "primary": true,
      "skipSearch": false
    }],
    "forte-di-orino": [{
      "hkey": "38c62df8",
      "slug": "cuvio",
      "name": "Cuvio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6b5f1684": [{
      "hkey": "38c62df8",
      "slug": "cuvio",
      "name": "Cuvio",
      "primary": true,
      "skipSearch": false
    }],
    "gaggio": [{
      "hkey": "38c62df8",
      "slug": "cuvio",
      "name": "Cuvio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eedce982": [{
      "hkey": "38c62df8",
      "slug": "cuvio",
      "name": "Cuvio",
      "primary": true,
      "skipSearch": false
    }],
    "pianezze": [{
      "hkey": "38c62df8",
      "slug": "cuvio",
      "name": "Cuvio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2507c953": [{
      "hkey": "38c62df8",
      "slug": "cuvio",
      "name": "Cuvio",
      "primary": true,
      "skipSearch": false
    }],
    "punta-merigett-campo-dei-fiori": [{
      "hkey": "38c62df8",
      "slug": "cuvio",
      "name": "Cuvio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "80216e6e": [{
      "hkey": "38c62df8",
      "slug": "cuvio",
      "name": "Cuvio",
      "primary": true,
      "skipSearch": false
    }],
    "ronco-brogini": [{
      "hkey": "38c62df8",
      "slug": "cuvio",
      "name": "Cuvio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f0d6b604": [{
      "hkey": "38c62df8",
      "slug": "cuvio",
      "name": "Cuvio",
      "primary": true,
      "skipSearch": false
    }],
    "roncora": [{
      "hkey": "38c62df8",
      "slug": "cuvio",
      "name": "Cuvio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;